import { sitewideTracking, bookingTracking, navigationTracking, socialTracking, shareTracking, callToActionTracking, footerTracking } from './tracking'

const setupTracking = () => {
  const rootDs = document.querySelector('[data-dl]')
  if (rootDs) {
    sitewideTracking()
    bookingTracking()
    navigationTracking()
    socialTracking()
    footerTracking()
    callToActionTracking()
    shareTracking()
  }
}

export {
  setupTracking
}
